

































































































import Teleport from '@/app/ui/components/Teleport/index.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import CloseIcon from '@/app/ui/assets/ics_o_close.vue'
import InputOTP from '@/app/ui/components/InputOTP/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import dayjs from 'dayjs'
import { recaptchaV3 } from '@/app/infrastructures/misc/RecaptchaV3'
import { EventBus, EventBusConstants } from '@/app/infrastructures/misc'

@Component({
  components: {
    Teleport,
    CloseIcon,
    InputOTP,
    Button,
  },
})
export default class VerifyOTPModal extends Vue {
  @Prop({ default: '', required: true, type: String })
  public otpErrorMessage!: string
  @Prop({ default: '', required: true, type: String }) public email!: string
  @Prop({ default: false, type: Boolean, required: true })
  public disabled!: boolean

  otp = ''
  requestOtpCountdown = 'Kirim ulang kode OTP dalam 03 : 00.'
  canRequestOTP = false
  countDownInterval: any = null

  get isOTPValid(): boolean {
    return this.otp.length === 6
  }

  mounted(): void {
    EventBus.$on(EventBusConstants.RESET_VERIFY_OTP_MODAL, (second = 120) => {
      this.otp = ''
      this.setOTPCountDown(second)
    })
  }

  unmounted(): void {
    if (this.countDownInterval) clearInterval(this.countDownInterval)
    localStorage.removeItem('otp-countdown')
    EventBus.$off(EventBusConstants.RESET_VERIFY_OTP_MODAL)
  }

  requestOTP(): void {
    this.$emit('request')
  }

  async verifyOTP(): Promise<void> {
    this.$emit('verify', this.otp)
  }

  setOTPCountDown(second = 120): void {
    this.canRequestOTP = false
    const existingCountdown = localStorage.getItem('otp-countdown')
    let retryCountdown = new Date(
      dayjs()
        .add(second, 'seconds')
        .toISOString()
    ).getTime()
    if (existingCountdown) {
      retryCountdown = Number(existingCountdown)
    }
    localStorage.setItem('otp-countdown', retryCountdown.toString())
    this.countDownInterval = setInterval(() => {
      const now = new Date().getTime()
      this.requestOtpCountdown = dayjs(retryCountdown - now).format(
        '[Kirim ulang kode OTP dalam] mm : ss.'
      )
      if (now >= retryCountdown && this.countDownInterval) {
        this.canRequestOTP = true
        clearInterval(this.countDownInterval)
      }
    }, 1)
  }

  onEnterOTP() {
    if (!this.isOTPValid) return;
    this.verifyOTP();
  }
}
